import "fslightbox";
import { tns } from "tiny-slider/src/tiny-slider";

let isDragging = false;

function getLargestFromSrcset(img: Element): string | null {
  const srcset = img.getAttribute("srcset") || img.getAttribute("data-srcset");
  if (!srcset) return null;

  let maxWidth = 0;
  let maxUrl = "";
  for (const entry of srcset.split(",")) {
    const [url, descriptor] = entry.trim().split(/\s+/);
    const width = parseInt(descriptor);
    if (width > maxWidth) {
      maxWidth = width;
      maxUrl = url;
    }
  }

  return maxUrl || null;
}

const galleries = document.querySelectorAll(".wp-block-gallery");
[...galleries].forEach((gallery, i) => {
  // setup lightbox

  const lightbox = new (window as any).FsLightbox();
  const sources: string[] = [];

  const images = gallery.querySelectorAll("img");
  images.forEach((img, i) => {
    const src = getLargestFromSrcset(img) || img?.getAttribute("data-src") || img?.getAttribute("src");
    if (!img || !src) return;
    sources.push(src);

    img.dataset.index = String(i);
  });

  lightbox.props.sources = sources;

  // handle slider
  const controls = `
        <div class="wp-block-gallery__controls">
          <button class="wp-block-gallery__prev wp-block-gallery__prev--${i}"></button>
          <span class="wp-block-gallery__counter wp-block-gallery__counter--${i}"><span class="font-bold">1</span>/${images.length}</span>
          <button class="wp-block-gallery__next wp-block-gallery__next--${i}"></button>
        </div>
      `;

  gallery.insertAdjacentHTML("afterend", controls);

  const slider = tns({
    container: gallery,
    gutter: 20,
    mouseDrag: true,
    prevButton: `.wp-block-gallery__prev--${i}`,
    nextButton: `.wp-block-gallery__next--${i}`,
    items: 1,
    responsive: {
      768: {
        items: 2,
      },
      1024: {
        items: 3,
      },
    },
  });

  const counter = document.querySelector(
    `.wp-block-gallery__counter--${i} span`,
  );

  slider.events.on("indexChanged", ((info: { displayIndex: number }) => {
    if (counter) {
      counter.textContent = `${info.displayIndex}`;
    }
  }) as any);

  slider.events.on("dragMove", () => {
    isDragging = true;
  });

  slider.events.on("dragEnd", () => {
    isDragging = false;
  });

  gallery.querySelectorAll("img").forEach((img) => {
    img.addEventListener("click", () => {
      if (isDragging) {
        return;
      }
      lightbox.open(Number(img.dataset.index));
    });
  });
});
